import { z } from 'zod';

export const slackNotifySchema = z.object({
  message: z.string().min(1).max(4000),
  channel: z.string().optional(),
});
export type SlackNotifyInput = z.infer<typeof slackNotifySchema>;

export const slackDmSchema = z.object({
  email: z.string().email(),
  message: z.string().min(1).max(4000),
});
export type SlackDmInput = z.infer<typeof slackDmSchema>;

export const slackCommandSchema = z.object({
  token: z.string(),
  team_id: z.string(),
  team_domain: z.string(),
  channel_id: z.string(),
  channel_name: z.string(),
  user_id: z.string(),
  user_name: z.string(),
  command: z.string(),
  text: z.string(),
  response_url: z.string().url(),
  trigger_id: z.string().optional(),
});
export type SlackCommandInput = z.infer<typeof slackCommandSchema>;
